(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trinity-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.tri-navigation-dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.tri-navigation-dropdown[open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trinity-home"] && !Shopify.designMode) return;
  try {
    
function initTrinity(){document.querySelectorAll('.tri-slider').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-tri-slide]')];if(!slides.length)return;let index=0;let paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const pause=root.querySelector('[data-tri-pause]');const show=(n)=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==index;});};const update=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-pressed',String(paused));};root.querySelector('[data-tri-prev]').addEventListener('click',()=>show(index-1));root.querySelector('[data-tri-next]').addEventListener('click',()=>show(index+1));pause.addEventListener('click',()=>{paused=!paused;update();});root.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){show(index+1);e.preventDefault();}if(e.key==='ArrowLeft'){show(index-1);e.preventDefault();}});setInterval(()=>{if(!root.isConnected)return;if(!paused&&!root.matches(':hover')&&!root.contains(document.activeElement)&&!document.hidden)show(index+1);},6500);update();});}initTrinity();document.addEventListener('shopify:section:load',initTrinity);

  } catch(e) { console.error(e); }
})();
})();
